"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M6 11v5a1 1 0 11-2 0V3a1 1 0 012 0v6h8V3a1 1 0 112 0v13a1 1 0 11-2 0v-5H6z"];
//# sourceMappingURL=header.js.map